/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Menu_OpenInputs */

const en_control_menu_open = /** @type {(inputs: Control_Menu_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const zh_control_menu_open = /** @type {(inputs: Control_Menu_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`菜单`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Control_Menu_OpenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_menu_open = /** @type {((inputs?: Control_Menu_OpenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Menu_OpenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_menu_open(inputs)
	return zh_control_menu_open(inputs)
});
export { control_menu_open as "control.menu.open" }